import React from 'react'

const Footer = () => {
  return (
    <footer className="py-12 px-4 md:px-6 bg-gradient-to-r from-[#2c3e50] to-[#34495e]">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">AuraSquare Events</h3>
            <p className="text-white/80 leading-relaxed mb-4">
              Chennai's best & premium event management company, specializing in creating unforgettable experiences for weddings, corporate events, birthdays, and celebrations of all kinds.
            </p>
          </div>

          <div>
            <h4 className="text-xl font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#services" className="text-white/80 hover:text-[#1abc9c] transition">Our Services</a></li>
              <li><a href="#decorations" className="text-white/80 hover:text-[#1abc9c] transition">Decorations</a></li>
              <li><a href="#entertainment" className="text-white/80 hover:text-[#1abc9c] transition">Entertainment</a></li>
              <li><a href="#photobooths" className="text-white/80 hover:text-[#1abc9c] transition">Photobooths</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-bold text-white mb-4">Services</h4>
            <ul className="space-y-2 text-white/80">
              <li>• Wedding Planning & Decoration</li>
              <li>• Corporate Event Management</li>
              <li>• Birthday Party Planning</li>
              <li>• Stage & Audio Setup</li>
              <li>• Photo & Video Booths</li>
              <li>• Carnival Games & Entertainment</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center">
          <p className="text-white/80 mb-4">
            <strong>Your Vision, Our Aura</strong>
          </p>
          <p className="text-white/60 text-sm">
            © 2026 AuraSquare Events. All rights reserved.
          </p>
          <div className="mt-4">
            <a href="https://wa.me/919444848616" className="text-white/80 hover:text-[#1abc9c] mx-3" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-whatsapp text-2xl"></i>
            </a>
            <a href="https://www.instagram.com/aurasquare.events" className="text-white/80 hover:text-[#1abc9c] mx-3" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram text-2xl"></i>
            </a>
            <a href="mailto:aurasquare.events@gmail.com" className="text-white/80 hover:text-[#1abc9c] mx-3">
              <i className="fas fa-envelope text-2xl"></i>
            </a>
            <a href="tel:+919444848616" className="text-white/80 hover:text-[#1abc9c] mx-3">
              <i className="fas fa-phone text-2xl"></i>
            </a>
            <a href="https://maps.app.goo.gl/LXQLXeChH4M59WY88" className="text-white/80 hover:text-[#1abc9c] mx-3" target="_blank" rel="noopener noreferrer">
              <i className="fas fa-map-marker-alt text-2xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
